import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, TextField } from '@material-ui/core';
import Container from '../../components/Container'
import Typo from '../../components/CustomTypo';
import Button from '../../components/ButtonCustom';
import { formatDateToDDMMYYYYFrEpoch, statementPeriodOption } from '../../utils/util';
import InfiniteScroll from 'react-infinite-scroll-component';
import CustomizedCircularProgress, { CustomizedCircularProgressLight } from '../../components/CircularProgress';
import { MyAccountIcon } from '../../components/icons';
import { DatePickerComponent, SelectComponent, TextFieldComponent } from '../../components/FormElement';
import { Field, Form } from 'react-final-form';
import { getContacts } from '../../utils/common';
import ModalConfirm from '../../components/ModalConfirm';
import ModalAlert from '../../components/ModalAlert';

const styles = theme => ({
    account_balance: {
        backgroundColor: theme.palette.background.primary,
        borderRadius: theme.shape.borderRadius2x,
        padding: theme.spacing(4),
        marginBottom: theme.spacing(3),
    },
    balance: {
        marginTop: theme.spacing(3),
    },
    filter: {
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(3),
        padding: theme.spacing(3),
    },
    table_data: {
        // backgroundColor: theme.palette.background.primary,
        // borderRadius: theme.spacing(3),
        // padding: theme.spacing(3),
        margin: theme.spacing(4, 0),
    },
    credit: {
        color: theme.palette.button.success.color,
        fontWeight: 'bold',
    },
    debit: {
        color: theme.palette.background.primary,
        fontWeight: 'bold',
    },
    table_row: {
        '&:hover': {
            cursor: 'pointer'
        }
    },
    filter_status: {
        [theme.breakpoints.down('lg')]: {
            padding: theme.spacing(3, 0),
        },
    },
    title_status: {
        [theme.breakpoints.up('lg')]: {
            marginLeft: theme.spacing(3) + 'px!important'
        }
    },
    //input
    inputRoot: {
        border: '1px solid',
        borderColor: theme.palette.border.secondary,
        borderRadius: 24,
        height: 48,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.secondary,
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
        marginTop: theme.spacing(1),
        position: 'relative'
    },
    inputLine: {
        width: '100%',
        // marginTop: theme.spacing(2),
    },
    form: {
        textAlign: 'center',
        justifyContent: 'center',
    },
});

function InvoiceView(props) {
    const { t, classes, accountFinance, currency, rows, cells, params, showFormAmount } = props;

    let balance_brought_forward = 0;
    let balance = accountFinance && accountFinance.balance ? accountFinance.balance : 0;
    let overdue_amount = accountFinance && accountFinance.overdue_amount ? accountFinance.overdue_amount : 0;
    let totalCredit = 0;
    const contactInfo = getContacts();
    return (
        <Container>
            <Grid item xs={12}>
                <Grid item xs={12} sm={6}>
                    <Grid xs={12} item className={classes.account_balance}>
                        <Grid xs={12} item container>
                            <Grid xs={1} item container alignItems='center'>
                                <Grid className={classes.bg_icon}>
                                    <MyAccountIcon style={{ margin: 0 }} />
                                </Grid>
                            </Grid>
                            <Grid item xs={11} container alignItems='center'>
                                <Typo variant='h6' color='onPrimary'>{t('account_finance')}</Typo>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container alignItems='center' className={classes.balance}>
                            <Grid item xs={6}>
                                <Typo variant="subtitle1" color="onPrimary">{t('contact_code')}</Typo>
                            </Grid>
                            <Grid item xs={6}>
                                <Typo variant="subtitle1" color="onPrimary">{contactInfo && contactInfo.code ? contactInfo.code : null}</Typo>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container alignItems='center' className={classes.balance}>
                            <Grid item xs={6}>
                                <Typo variant="subtitle1" color="onPrimary">{t('my_account_number')}</Typo>
                            </Grid>
                            <Grid item xs={6}>
                                <Typo variant="subtitle1" color="onPrimary">{accountFinance.number ? accountFinance.number : null} {accountFinance.currency_code ? "(" + accountFinance.currency_code + ")" : null}</Typo>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container>
                            <Grid item xs={12}>
                                <Grid item xs={12} container direction='row' className={classes.balance}>
                                    <Grid item xs={6}>
                                        <Typo variant="subtitle1" color='onPrimary'>{t('account_balance')}</Typo>
                                        <Grid item xs={12} container alignItems='center'>
                                            <Typo variant="h6" color="onPrimary">{currency}{balance.toFixed(2)}</Typo>
                                            {accountFinance && accountFinance.balance > 0 && <Button size="sm" onClick={() => props.onConfirmPay()} color="onPrimary" style={{ marginLeft: 10 }}>
                                                <Typo>{t('btn_pay')}</Typo>
                                            </Button>}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typo variant="subtitle1" color='onPrimary'>{t('overdue_amount')}</Typo>
                                        <Grid item xs={12} container alignItems='center'>
                                            <Typo variant="h6" color="onPrimary">{currency}{overdue_amount.toFixed(2)}</Typo>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} container alignItems='center'>
                    <Grid item xs={12} lg={6}>
                        <Form
                            onSubmit={props.onFilter}
                            // initialValues={{ ...props.specificPeriod, transaction_type: params && params.transaction_type ? params.transaction_type : null}}
                            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                <Grid item xs={12} className={classes.filter}>
                                    {/* <FormAutoSave debounce={1000} save={props.onFilter} /> */}
                                    <Grid item xs={12} container alignItems='center' className={classes.period}>
                                        <Grid item xs={12} container alignItems='center'>
                                            <Grid item xs={2}>
                                                <Typo variant="input_label" color='default'>{t('transaction_type')}</Typo>
                                            </Grid>
                                            <Grid item xs={10} container alignItems='center'>
                                                <Grid item xs={12}>
                                                    <Field
                                                        name="transaction_type"
                                                        // label={t('period_title')}
                                                        component={SelectComponent}
                                                        selectData={props.transactionTypes}
                                                        valueSelect={params && params.transaction_type ? params.transaction_type : null}
                                                        onSelectedChange={(event) => props.onChangeType(event.target.value)}
                                                        color='default'
                                                        placeholder={t('Select')}
                                                        isEdit={true}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} container alignItems='center'>
                                            <Grid item xs={2}>
                                                <Typo variant="input_label" color='default'>{t('period_title')}</Typo>
                                            </Grid>
                                            <Grid item xs={10} container alignItems='center'>
                                                <Grid item xs={12}>
                                                    <Field
                                                        name="period"
                                                        // label={t('period_title')}
                                                        component={SelectComponent}
                                                        selectData={props.listPeriods}
                                                        valueSelect={props.periodSeleted}
                                                        onSelectedChange={(event) => props.onSelectPeriod(event)}
                                                        color='default'
                                                        placeholder={t('Select')}
                                                        isEdit={true}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {props.periodSeleted == statementPeriodOption.SPECIFIC_PERIOD && <>
                                            <Grid item xs={12} container spacing={2}>
                                                <Grid item xs={6}>
                                                    <Field
                                                        name="from_date"
                                                        component={DatePickerComponent}
                                                        label={t('from_date')}
                                                        color='default'
                                                        isEdit={true}
                                                        valuez={props.specificPeriod.from_date}
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Field
                                                        name="to_date"
                                                        component={DatePickerComponent}
                                                        label={t('to_date')}
                                                        color='default'
                                                        isEdit={true}
                                                        valuez={props.specificPeriod.to_date}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </>}
                                        <Grid item xs={12} style={{ textAlign: 'center' }}>
                                            <Button color='primary' size='sm' onClick={handleSubmit}>{t('btn_submit')}</Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}
                        />
                    </Grid>
                    {/* <Grid item xs={12} lg={6} className={classes.filter_status}>
                        <Grid item xs={12} container spacing={2} alignItems='center' className={classes.title_status}>
                            <Button color={params && params.transaction_type === 'INVOICE' ? 'primary' : 'onPrimary'} size='sm' round={false}>
                                <Typo variant='overline' onClick={() => props.onChangeType('INVOICE')}>{t('invoice')}</Typo>
                            </Button>
                            <Button color={params && params.transaction_type === 'PAYMENT' ? 'primary' : 'onPrimary'} size='sm' round={false}>
                                <Typo variant='overline' onClick={() => props.onChangeType('PAYMENT')}>{t('payment')}</Typo>
                            </Button>
                        </Grid>
                    </Grid> */}
                </Grid>
                <Grid item xs={12} className={classes.table_data}>
                    <TableContainer component={Paper} style={{ borderRadius: 12 }}>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    {cells && cells.length && cells.map((cell, index) => {
                                        if (params.transaction_type === 'PAYMENT') {
                                            if (cell.id === 'due_date' || cell.id === 'unpaid_amount' || cell.id === 'paid_amount') {
                                                return null;
                                            } else {
                                                return (
                                                    <TableCell key={index} id={cell.id} align={cell.align}>
                                                        <Typo variant="subtitle2">{cell.name}</Typo>
                                                    </TableCell>
                                                );
                                            }
                                        }
                                        else {
                                            return (
                                                <TableCell key={index} id={cell.id} align={cell.align}>
                                                    <Typo variant="subtitle2">{cell.name}</Typo>
                                                </TableCell>
                                            );
                                        }
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.showLoadMore && <TableRow>
                                    <TableCell component="th" scope="row" colSpan={3} align="center">
                                        <CustomizedCircularProgressLight />
                                    </TableCell>
                                </TableRow>}
                                {rows && rows.length > 0 && rows.map((row, index) => {
                                    // if (row.type == 'CREDIT') totalCredit += row.amount
                                    // else totalDebit += row.amount;
                                    return (
                                        <TableRow key={index} onClick={() => props.onDetailInvoice(row)} className={classes.table_row}>
                                            <TableCell component="td" scope="row">
                                                <Typo>{row.number ? row.number : ""}</Typo>
                                            </TableCell>
                                            {params.transaction_type !== 'PAYMENT' && <TableCell component="td" scope="row">
                                                <Typo>{row.invoice && row.invoice.due_date ? formatDateToDDMMYYYYFrEpoch(row.invoice.due_date) : null}</Typo>
                                            </TableCell>}
                                            <TableCell component="td" scope="row">
                                                <Typo>{row.posted_date ? formatDateToDDMMYYYYFrEpoch(row.posted_date) : null}</Typo>
                                            </TableCell>
                                            <TableCell component="td" scope="row">
                                                <Typo>{row.transaction_type ? getType(row.transaction_type, t) : null}</Typo>
                                            </TableCell>
                                            <TableCell component="td" scope="row" align="right">
                                                {row.type == 'CREDIT' && <Typo className={classes.credit}>{currency}{row.amount ? Number(row.amount).toFixed(2) : "0.00"}</Typo>}
                                                {row.type == 'DEBIT' && <Typo className={classes.debit}>{currency}{row.amount ? Number(row.amount).toFixed(2) : "0.00"}</Typo>}
                                            </TableCell>
                                            {params.transaction_type !== 'PAYMENT' && <TableCell component="td" scope="row" align="right">
                                                {row.invoice && <Typo>{currency}{row.invoice.unpaid_amount ? Number(row.invoice.unpaid_amount).toFixed(2) : "0.00"}</Typo>}
                                            </TableCell>}
                                            {/* {params.transaction_type !== 'PAYMENT' && <TableCell component="td" scope="row" align="right">
                                                {row.invoice && <Typo>{currency}{row.invoice.paid_amount ? Number(row.invoice.paid_amount).toFixed(2) : "0.00"}</Typo>}
                                            </TableCell>} */}
                                        </TableRow>
                                    );
                                })}
                                {/* <TableRow>
                                    <TableCell component="td" scope="row" colSpan={4} align="right">
                                        <Typo variant="subtitle2">{t('balance')}</Typo>
                                    </TableCell>
                                    <TableCell component="td" scope="row" colSpan={4} align="right">
                                        <Grid item xs={12} container alignItems='center'>
                                            <Grid item xs={6}>
                                                <Typo>{currency}{(totalCredit - totalDebit).toFixed(2)}</Typo>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                </TableRow> */}
                            </TableBody>
                        </Table>

                        <TablePagination
                            rowsPerPageOptions={[10]}
                            component="div"
                            count={props.paging && props.paging.total ? props.paging.total : 0}
                            rowsPerPage={10}
                            page={props.paging && props.paging.page ? props.paging.page - 1 : 0}
                            onPageChange={props.handleChangePage}
                        />
                    </TableContainer>
                </Grid>
            </Grid>
            {showFormAmount && <FormAmount
                t={t}
                classes={classes}
                open={showFormAmount}
                onPay={props.onPay}
                onChangeAmount={props.onChangeAmount}
                onClose={() => props.setShowFormAmount(false)}
            />}
        </Container >
    );
}

function FormAmount(props) {
    const { t, classes, open, onClose, onPay, onChangeAmount, amount } = props;
    return (
        <ModalAlert
            open={open}
            isCustomMessage={true}
            hideButtonClose={true}
            message={
                <Grid item xs={12} className={classes.form}>
                    <Grid item xs={12} style={{textAlign: 'left'}}>
                        <Typo variant="body2">{t('Amount')}</Typo>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            name="amount"
                            id="amount"
                            type='number'
                            placeholder={t('enter_amount')}
                            value={amount ? amount.toFixed(2) : null}
                            className={classes.inputLine}
                            onChange={(event) => onChangeAmount(event.target.value)}
                            InputProps={{
                                disableUnderline: true,
                                classes: { root: classes.inputRoot },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} container style={{marginTop: 10, justifyContent: 'center'}}>
                        <Button size="sm" onClick={() => onClose()}>{t('btn_cancel')}</Button>
                        <Button size="sm" color="primary" onClick={() => onPay()}>{t('btn_pay')}</Button>
                    </Grid>
                </Grid>
            }
            onClose={() => onClose()}
        />
    );
}

function getType(type, t) {
    if (type == 'INVOICE')
        return t('invoice_title');
    else if (type == 'TOP_UP')
        return t('topup_title');
    else if (type == 'CREDIT_NOTE')
        return t('credit_note');
    else if (type == 'PAYMENT')
        return t('payment');
    else if (type == 'REFUND')
        return t('refund');
    else if (type == 'PAYOUT')
        return t('payout');
    else if (type == 'TRANSFER')
        return t('transfer');
    else if (type == 'MANUAL_JOURNAL')
        return t('manual_journal');
    else return null;
}
export default withStyles(styles)(withTranslation()(InvoiceView));
